/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AboutService {

    private specialOrdersUrl = `${environment.baseUrl}/ms-specialorders/api/status/ready`;
    private specialOrderAdapterUrl = `${environment.baseUrl}/ag-specialorder-adapter/api/status/ready`;
    private claimsUrl = `${environment.baseUrl}/ms-claims/api/status/ready`;
    private claimAdapterUrl = `${environment.baseUrl}/ag-claim-adapter/api/status/ready`;
    private securityUrl = `${environment.baseUrl}/ms-security/api/status/ready`;
    private settingsUrl = `${environment.baseUrl}/ms-settings/api/status/ready`;
    private eventsUrl = `${environment.baseUrl}/ms-events/api/status/ready`;
    private oauthProxyUrl = `${environment.baseUrl}/ms-oauth-proxy/api/status/ready`;
    private materialSchedulerUrl = `${environment.baseUrl}/ag-material-version-scheduler/api/status/ready`;
    private materialAdapterUrl = `${environment.baseUrl}/ag-material-adapter/api/status/ready`;
    private guiUrl = `${environment.baseUrl}/healthz`;
    private fileManagerUrl = `${environment.baseUrl}/ms-filemanager/api/status/ready`;
    private partNumberChangesUrl = `${environment.baseUrl}/ms-partnumberchanges/api/status/ready`;
    private settlementsUrl = `${environment.baseUrl}/ms-settlements/api/status/ready`;
    private bundlesUrl = `${environment.baseUrl}/ms-bundles/api/status/ready`;

    constructor(private http: HttpClient) {
    }

    getSpecialOrdersVersion(): Observable<string> {
        return this.http.get(this.specialOrdersUrl, {responseType: 'text'});
    }

    getSpecialOrderAdapterVersion(): Observable<string> {
        return this.http.get(this.specialOrderAdapterUrl, {responseType: 'text'});
    }

    getClaimsVersion(): Observable<string> {
        return this.http.get(this.claimsUrl, {responseType: 'text'});
    }

    getClaimAdapterVersion(): Observable<string> {
        return this.http.get(this.claimAdapterUrl, {responseType: 'text'});
    }

    getSecurityVersion(): Observable<string> {
        return this.http.get(this.securityUrl, {responseType: 'text'});
    }

    getSettingsVersion(): Observable<string> {
        return this.http.get(this.settingsUrl, {responseType: 'text'});
    }

    getEventsVersion(): Observable<string> {
        return this.http.get(this.eventsUrl, {responseType: 'text'});
    }

    getOauthProxyVersion(): Observable<string> {
        return this.http.get(this.oauthProxyUrl, {responseType: 'text'});
    }

    getMaterialSchedulerVersion(): Observable<string> {
        return this.http.get(this.materialSchedulerUrl, {responseType: 'text'});
    }

    getMaterialAdapterVersion(): Observable<string> {
        return this.http.get(this.materialAdapterUrl, {responseType: 'text'});
    }

    getGuiVersion(): Observable<string> {
        return this.http.get(this.guiUrl, {responseType: 'text'});
    }

    getFileManagerVersion(): Observable<string> {
        return this.http.get(this.fileManagerUrl, {responseType: 'text'});
    }

    getPartNumberChangesVersion(): Observable<string> {
        return this.http.get(this.partNumberChangesUrl, {responseType: 'text'});
    }

    getSettlementsVersion(): Observable<string> {
        return this.http.get(this.settlementsUrl, {responseType: 'text'});
    }

    getBundlesVersion(): Observable<string> {
        return this.http.get(this.bundlesUrl, {responseType: 'text'});
    }
}
